var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 14.6673C4.3167 14.6673 1.33203 11.6827 1.33203 8.00065C1.33203 4.31865 4.3167 1.33398 7.9987 1.33398C11.6807 1.33398 14.6654 4.31865 14.6654 8.00065C14.6654 11.6827 11.6807 14.6673 7.9987 14.6673ZM7.9987 13.3339C10.9442 13.3339 13.332 10.9461 13.332 8.00058C13.332 5.05507 10.9442 2.66725 7.99873 2.66724C5.05321 2.66723 2.66539 5.05503 2.66538 8.00054C2.66536 10.9461 5.05316 13.3339 7.99867 13.3339H7.9987ZM4.66536 8.00073H5.9987C5.9987 9.1053 6.89412 10.0007 7.99869 10.0007C9.10326 10.0007 9.99869 9.10531 9.9987 8.00074L11.332 8.00073C11.332 9.19162 10.6967 10.292 9.66536 10.8875C8.63403 11.4829 7.36337 11.4829 6.33203 10.8875C5.30069 10.292 4.66536 9.19162 4.66536 8.00073Z",
    fill: "#5D94D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryAlertIcon);
export default __webpack_public_path__ + "static/media/primaryAlertIcon.b3864c7300e13010d76e81c47bb8b895.svg";
export { ForwardRef as ReactComponent };